import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../scripts/control';
import { ROUTES } from '../../../config/constants';
import '../../css/BdStyles.css';

const BdLoginPage = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/bd_login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
        credentials: 'include'
      });

      if (!response.ok) {
        // Intentar obtener el mensaje de error del servidor
        try {
          const errorData = await response.json();
          throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        } catch (parseError) {
          throw new Error(`Error del servidor: ${response.status}`);
        }
      }

      const data = await response.json();
      
      if (data.success) {
        // Guardamos la información en localStorage
        localStorage.setItem('loggedIn', 'true');
        localStorage.setItem('role', data.role);
        login(data.role);
        
        // Redirigir después del login exitoso
        navigate(ROUTES.BD);
      } else {
        setError(data.message || 'Credenciales inválidas');
      }
    } catch (error) {
      setError('Ocurrió un error. Por favor, inténtalo nuevamente.');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="bd">
      <div className="container">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <input 
            type="text" 
            placeholder="Usuario" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
            style={{ marginBottom: '10px', padding: '10px', width: 'auto', marginLeft: '10px', marginTop: '10px' }}
          />
          <div style={{ position: 'relative', display: 'inline-block', marginBottom: '10px', marginLeft: '10px' }}>
            <input 
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              style={{ padding: '10px', width: 'auto' }}
            />
            <span 
              onClick={togglePasswordVisibility} 
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#555',
              }}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </span>
          </div>
          <button type="submit" style={{ padding: '10px 20px', marginLeft: '10px' }}>Login</button>
        </form>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>
    </div>
  );
};

export default BdLoginPage;
